<template>
  <div class="absolute top-0 bottom-0 w-full h-full z-2 bg-white">
    <div class="relative w-full h-full overflow-hidden">
        <iframe :src="url" class="w-full h-full"></iframe>
        <div @click="close" class="absolute bottom-10 left-0 bg-white w-56 h-56 back-button flex items-center content-center">
            <WFIcon class="h-6 w-12 m-auto" name="back"></WFIcon>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        url: {
            default: "",
            type: String
        }
    },
    data() {
        return {
            qr: null,
        };
    },
    watch: {
        poi() {
        },
    },
    mounted() {

    },
    methods: {
        getCoordinatesFromGoogleMapURL:  (url) => {
            if (!url) {
                return undefined
            }
            const parsedUrl = new URL(url);
            const viewpoint = parsedUrl.searchParams.get("viewpoint");
           
            if (!viewpoint) return undefined;
            
            const [latStr, lngStr] = viewpoint.split(",");

            const lat = parseFloat(latStr);
            const lng = parseFloat(lngStr);

            if (isNaN(lat) || isNaN(lng)) return null;

            return [lat, lng]
        },
        generateGoogleMapEmbedUrl: (coordinates) => {
            if (!coordinates) {
                return undefined
            }

            const baseUrl = "https://www.google.com/maps/embed/v1/streetview"
            const coordinatesString = `${String(coordinates[0])},${String(coordinates[1])}`
            const url = `${baseUrl}?key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}&location=${coordinatesString}`
            
            return url
        },
        close () {
            this.$emit("close");
        }
    },
};
</script>